/** Paydirt tenant — enable claim-links tab and vertical product UI embeds. */

export { ClaimBadges } from '@/domains/paydirt/ClaimBadges';
export { ProductKindBadge } from '@/domains/paydirt/products/ProductKindBadge';
export { PaydirtProductStatsPanel as VerticalProductStatsPanel } from '@/domains/paydirt/products/PaydirtProductStats';
export {
  PRODUCT_KIND_OPTIONS as VERTICAL_PRODUCT_KIND_OPTIONS,
  isPaydirtProductKind as isVerticalProductKind,
  isValidProductKind,
  productKindDescriptionHint,
  productKindLabel as verticalProductKindLabel,
  productKindRequiresDescription,
  type ProductKind as VerticalProductKind,
} from '@/domains/paydirt/products/productKinds';

export const marketplaceExtensions = {
  showClaimLinksTab: true,
};
